import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DownloadBuildModule } from 'mbs-ui-shared@components/download-build/download-build.module';
import { DownloadConnectComponent } from 'mbs-ui-shared@components/download-connect/download-connect.component';

@NgModule({
  imports: [CommonModule, DownloadBuildModule, DownloadConnectComponent],
  exports: [DownloadConnectComponent]
})
export class DownloadConnectModule {}
